export const MOBILE_WIDTH = 767;
export const TABLET_WIDTH = 1023;
export const SMALL_DESKTOP_WIDTH = 1366;
export const DESKTOP_WIDTH = 1440;
